import React from "react";

export const LazyWormSlackViewerBridge = React.lazy(
    () => import(/* webpackChunkName: "ChatViewer" */ "./WormSlackViewer")
);
